import {
  GET_INVOICE_SUCCESS,
  GET_INVOICE_FAILED,
  RESET_GET_INVOICE,
  LOADING_GET_INVOICE,
  NETWORK_ERROR_GET_INVOICE,
} from "../types/index";
import { invoiceServices } from "../../config/axios";

const resetgetInvoices = () => {
  return { type: RESET_GET_INVOICE };
};

const getInvoices = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GET_INVOICE });
  await invoiceServices
    .post("getInvoices", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getInvoicesuccess(res.data));
          break;
        default:
          dispatch(getInvoiceFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GET_INVOICE,
        payload: err,
      });
    });
};
function getInvoicesuccess(data) {
  return {
    type: GET_INVOICE_SUCCESS,
    payload: data,
  };
}
function getInvoiceFailed(data) {
  return {
    type: GET_INVOICE_FAILED,
    payload: data,
  };
}

export { resetgetInvoices, getInvoices };
